var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimateFavNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "10b33f4280"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0edee1edcc"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#10b33f4280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7ff8accf8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.179688 L 19.40625 0.179688 L 19.40625 21.082031 L 0.359375 21.082031 Z M 0.359375 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6d73ee0e6b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7286b38994"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.335938 2.597656 L 25.382812 2.597656 L 25.382812 26.546875 L 4.335938 26.546875 Z M 4.335938 2.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "04f60e5511"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#10b33f4280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f533c19381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.335938 1 L 21 1 L 21 24 L 0.335938 24 Z M 0.335938 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "21859c067b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.335938 0.597656 L 21.382812 0.597656 L 21.382812 24.546875 L 0.335938 24.546875 Z M 0.335938 0.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "32d58e500c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 22,
    y: 0,
    height: 25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0575093, 0, 0, 0.0585579, 4.334155, 2.597907)",
    fillOpacity: 1,
    fill: "#097437",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 208.693066 301.913785 C 193.138504 311.052711 173.916055 311.252833 158.225645 302.31403 L 111.697807 275.964574 C 95.939474 267.092478 86.226363 250.482315 86.090515 232.404586 L 85.615048 178.971891 C 85.479201 160.894163 94.98854 144.150584 110.543102 135.011659 L 156.663396 107.92842 C 172.217958 98.722787 191.440408 98.589372 207.130818 107.461468 L 253.658656 133.877632 C 269.349065 142.749727 279.1301 159.359891 279.265948 177.370911 L 279.741414 230.870314 C 279.877262 248.948042 270.367923 265.691621 254.813361 274.830546 Z M 86.973525 231.937634 C 87.109373 249.948655 96.822484 266.558818 112.580817 275.430914 L 158.157721 301.313418 C 173.916055 310.185513 193.138504 310.052098 208.693066 300.913173 L 253.930351 274.296887 C 269.484913 265.157961 278.994252 248.414383 278.790481 230.403362 L 278.382937 177.904571 C 278.24709 159.893551 268.466055 143.283387 252.775646 134.411291 L 207.130818 108.528787 C 191.440408 99.589984 172.217958 99.790107 156.663396 108.929032 L 111.426112 135.545319 C 95.87155 144.684244 86.362211 161.427823 86.498058 179.438844 Z M 86.973525 231.937634 ",
    stroke: "#097437",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0edee1edcc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6d73ee0e6b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#097437",
    d: "M 11.460938 18.941406 C 10.503906 19.515625 9.316406 19.527344 8.347656 18.96875 L 3.546875 16.199219 C 2.582031 15.640625 1.980469 14.597656 1.96875 13.464844 L 1.925781 7.847656 C 1.917969 6.714844 2.503906 5.664062 3.460938 5.089844 L 8.21875 2.242188 C 9.175781 1.667969 10.363281 1.660156 11.328125 2.214844 L 16.128906 4.988281 C 17.097656 5.546875 17.699219 6.585938 17.707031 7.71875 L 17.75 13.335938 C 17.761719 14.46875 17.175781 15.519531 16.21875 16.09375 Z M 2.042969 13.421875 C 2.050781 14.554688 2.652344 15.597656 3.621094 16.152344 L 8.347656 18.882812 C 9.316406 19.441406 10.5 19.429688 11.460938 18.855469 L 16.144531 16.050781 C 17.101562 15.476562 17.6875 14.425781 17.679688 13.292969 L 17.636719 7.761719 C 17.625 6.628906 17.023438 5.589844 16.058594 5.03125 L 11.328125 2.300781 C 10.363281 1.742188 9.175781 1.753906 8.21875 2.328125 L 3.535156 5.132812 C 2.574219 5.707031 1.988281 6.757812 2 7.890625 Z M 2.042969 13.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7ff8accf8)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0575093, 0, 0, 0.0585579, -0.665845, -1.402093)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 210.86663 347.40829 C 194.225286 357.21429 173.576435 357.414412 156.73132 347.875242 L 73.252907 300.579636 C 56.475716 291.040465 46.015443 273.229567 45.811672 253.884396 L 45.064509 157.959033 C 44.928661 138.613863 55.117239 120.66955 71.758583 110.863549 L 154.489833 62.233793 C 171.131177 52.427793 191.780027 52.294378 208.557219 61.766841 L 292.035632 109.129155 C 308.880747 118.668325 319.34102 136.412516 319.476867 155.757686 L 320.22403 251.683049 C 320.427801 271.02822 310.239224 288.972533 293.59788 298.778533 Z M 47.102225 253.150614 C 47.238072 272.495785 57.698345 290.306683 74.543461 299.779146 L 156.73132 346.407677 C 173.576435 355.946848 194.157362 355.746725 210.86663 345.940725 L 292.307327 298.044751 C 308.94867 288.238751 319.137248 270.294438 319.0014 250.949267 L 318.254238 156.491469 C 318.050466 137.146298 307.590193 119.402107 290.813002 109.862937 L 208.557219 63.234405 C 191.780027 53.695235 171.131177 53.895357 154.489833 63.701358 L 73.049136 111.597332 C 56.339868 121.403332 46.151291 139.347645 46.355062 158.692816 Z M 47.102225 253.150614 ",
    stroke: "#097437",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7286b38994)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#04f60e5511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#32d58e500c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f533c19381)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#097437",
    d: "M 12.761719 23.367188 C 11.640625 24.035156 10.257812 24.046875 9.128906 23.398438 L 2.644531 19.652344 C 1.515625 19.003906 0.8125 17.789062 0.800781 16.46875 L 0.742188 8.875 C 0.730469 7.554688 1.414062 6.328125 2.53125 5.660156 L 8.957031 1.8125 C 10.078125 1.140625 11.460938 1.132812 12.589844 1.78125 L 19.074219 5.523438 C 20.203125 6.175781 20.90625 7.390625 20.917969 8.710938 L 20.976562 16.300781 C 20.988281 17.625 20.304688 18.847656 19.1875 19.519531 Z M 0.894531 16.410156 C 0.90625 17.734375 1.605469 18.949219 2.734375 19.597656 L 9.128906 23.289062 C 10.257812 23.9375 11.640625 23.929688 12.757812 23.257812 L 19.09375 19.464844 C 20.210938 18.796875 20.894531 17.570312 20.882812 16.25 L 20.824219 8.765625 C 20.8125 7.445312 20.113281 6.230469 18.984375 5.578125 L 12.589844 1.890625 C 11.460938 1.238281 10.078125 1.25 8.960938 1.921875 L 2.625 5.714844 C 1.507812 6.382812 0.824219 7.609375 0.835938 8.929688 Z M 0.894531 16.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#21859c067b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0575093, 0, 0, 0.0585579, 0.334155, 0.597907)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 216.096766 388.833638 C 196.602621 400.240618 172.557577 400.44074 152.927584 389.367298 L 40.173992 325.39482 C 20.543999 314.321377 8.317706 293.57535 8.113934 271.02822 L 7.095076 141.34887 C 6.891305 118.80174 18.777979 97.85559 38.2042 86.44861 L 149.938935 20.741738 C 169.43308 9.26805 193.478124 9.134635 213.108117 20.208078 L 325.861709 84.113848 C 345.491702 95.253998 357.717995 116.000026 357.921767 138.547155 L 358.940625 268.159798 C 359.144396 290.773635 347.257722 311.653078 327.831501 323.126765 Z M 9.744107 270.027608 C 9.947878 292.641445 22.106247 313.387473 41.73624 324.460915 L 152.927584 387.499488 C 172.557577 398.57293 196.602621 398.439515 216.028842 386.965828 L 326.201328 322.192861 C 345.62755 310.785881 357.514224 289.83973 357.310452 267.292601 L 356.291594 139.48106 C 356.087823 116.93393 343.929454 96.187903 324.299461 85.047753 L 213.108117 22.075887 C 193.478124 10.935737 169.43308 11.13586 150.006859 22.609547 L 39.834373 87.382515 C 20.408151 98.789495 8.521477 119.735645 8.725249 142.282775 Z M 9.744107 270.027608 ",
    stroke: "#097437",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateFavNew);
export default __webpack_public_path__ + "static/media/climateFavNew.ffaad4e7fc2ed6474fadbe525042b369.svg";
export { ForwardRef as ReactComponent };